import { __assign, __spreadArray } from 'tslib';
import { useCallback } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import { v4 } from 'uuid';
import { notificationsAtom } from './atoms.js';
import { NotificationSize, NotificationPosition, NotificationDuration, NotificationType } from './models.js';
import { notificationPositionnedSelector } from './selectors.js';

var useNotificationsCenter = function () {
    var _a = useRecoilState(notificationsAtom), notifications = _a[0], setNotifications = _a[1];
    var notificationPositionned = useRecoilValue(notificationPositionnedSelector);
    var push = useCallback(function (notification, uniqueNotificationId) {
        var _a, _b, _c, _d, _e;
        var id = uniqueNotificationId || v4();
        var timestamp = Date.now();
        // Set a default
        var pushNotification = __assign(__assign({ id: id, timestamp: timestamp }, notification), { dismissable: (_a = notification === null || notification === void 0 ? void 0 : notification.dismissable) !== null && _a !== void 0 ? _a : true, size: (_b = notification === null || notification === void 0 ? void 0 : notification.size) !== null && _b !== void 0 ? _b : NotificationSize.Medium, position: (_c = notification === null || notification === void 0 ? void 0 : notification.position) !== null && _c !== void 0 ? _c : NotificationPosition.TopRight, duration: (_d = notification === null || notification === void 0 ? void 0 : notification.duration) !== null && _d !== void 0 ? _d : NotificationDuration.Regular, type: (_e = notification === null || notification === void 0 ? void 0 : notification.type) !== null && _e !== void 0 ? _e : NotificationType.Primary });
        setNotifications(function (previousNotifications) {
            // Do not push the same notification twice
            if (previousNotifications.some(function (n) { return n.id === id; })) {
                return previousNotifications;
            }
            return __spreadArray(__spreadArray([], previousNotifications, true), [pushNotification], false);
        });
        return id;
    }, [setNotifications]);
    var pull = useCallback(function (id) {
        return notifications.find(function (n) { return n.id === id; });
    }, [notifications]);
    var dismiss = useCallback(function (id) {
        setNotifications(function (prevNotifications) { return prevNotifications.filter(function (n) { return n.id !== id; }); });
    }, [setNotifications]);
    var dismissAll = useCallback(function () {
        setNotifications([]);
    }, [setNotifications]);
    return {
        push: push,
        pull: pull,
        dismiss: dismiss,
        dismissAll: dismissAll,
        notifications: notifications,
        notificationPositionned: notificationPositionned
    };
};

export { useNotificationsCenter };
//# sourceMappingURL=hooks.js.map
